import React from 'react'
import { useSwiper } from 'swiper/react'
import { CarouselButtonProps } from './Carousel.types'

const CarouselButton = ({
  children,
  direction = 'Next',
  ...props
}: CarouselButtonProps) => {
  const swiper = useSwiper()
  return (
    <button
      {...props}
      type='button'
      onClick={() => {
        if (direction === 'Next') {
          swiper.slideNext()
        } else {
          swiper.slidePrev()
        }
      }}>
      {children}
    </button>
  )
}

export { CarouselButton }
